import React from "react"
import useWindowSize from "../../utility/useWindowSize";
import {CmArticleType} from "../types";
import CCOContainer from "./CCOContainer";
import CCORichText from "./CCORichText/CCORichText";
import CCOComponentWrapper from "./CCOComponentWrapper";
import {getContainerWidth} from "../../utility/componentUtil";
import type { CAEGlobalSettings } from "../../types/CAEGlobalSettings";

interface Props {
    item: CmArticleType,
    layoutSettings?: any,
    noTopMargin?: boolean,
    noBottomMarginOnDesktop?: boolean,
    CAEGlobalSettings?: CAEGlobalSettings,
}

function renderArticle(props: Props) {
    const containerWidth = getContainerWidth(props.layoutSettings?.contentWidth);
    return <CCOContainer id={props.item.id} width={containerWidth}>
        <CCORichText metadataId={props.item.id} propertyName='properties.detailText' textAsTree={props.item?.detailText?.textAsTree}
                     docType={'article'} caeGlobalSettings={props.CAEGlobalSettings}></CCORichText>
    </CCOContainer>
}

function CCOArticle(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize();
    return (
        <CCOComponentWrapper
            noBottomMargin={(props.noBottomMarginOnDesktop || props.layoutSettings?.noBottomMargin) &&
                            greaterThanWindowMedium}
            noTopMargin={props.noTopMargin}
        >
            {renderArticle(props)}
        </CCOComponentWrapper>)
}

export default CCOArticle